// Unpublished Work © 2021-2025 Deere & Company.

import styles from '../../../views/edit-jdf-customer/jdf-business-read-only.module.scss';

export const individualNameFieldKeys = {
    FAMILIAR: 'familiarName',
    FIRST: 'firstName',
    GENERATION: 'generationId',
    LAST: 'lastName',
    MIDDLE: 'middleName',
    PREFIX: 'prefixId',
    SUFFIX: 'suffix',
    USCTZNIND: 'usCtnzInd',
    DOB: 'birthDate',
    SSN: 'ssn',
    GSTHSTNUMBER: 'gstHstNumber',
    QSTNUMBER: 'qstNumber'
};

export const contactPhoneFieldKeys = {
    AREA_CODE: 'areaCode',
    COUNTRY_CODE: 'countryCode',
    EXTENSION: 'extension',
    PHONE: 'phoneNumber',
    FORMATTED_PHONE: 'formattedPhone'
};

export const businessNameFieldKeys = {
    BUSINESS_NAME_ONE: 'businessName1',
    BUSINESS_NAME_TWO: 'businessName2',
    TAX_COUNTRY_CODE: 'taxCountryCode',
    TAX_ID: 'taxId',
    TRADING_AS: 'doingBusinessAs',
    BUSINESS_TYPE: 'businessType',
    STATE_PROVINCE: 'stateProvince'
};

export const contactInformationFieldKeys = {
    EMAIL: 'email',
    HOME_FAX: 'homeFax',
    HOME_PHONE: 'homePhone',
    MOBILE_PHONE: 'mobilePhone',
    PREFERRED_LANGUAGE: 'preferredLanguage',
    OFFICE_PHONE: 'officePhone',
    WORK_FAX: 'workFax',
    WORK_PHONE: 'workPhone'
};

export const addCustomerTabIndex = {
    INDIVIDUAL_CUSTOMER: 1,
    BUSINESS_CUSTOMER: 2,

    PREFIX: 9,
    FIRST: 10,
    FAMILIAR: 11,
    MIDDLE: 12,
    MIDDLE_NAME_CHECKBOX: 13,
    LAST: 14,
    GENERATION: 15,
    SUFFIX: 16,
    DATE_OF_BIRTH: 17,
    US_CTZ_YES: 18,
    US_CTZ_NO: 19,
    SSN: 20,

    BUSINESS_NAME_ONE: 21,
    BUSINESS_NAME_TWO: 22,
    DOING_BUSINESS_AS: 23,
    BUSINESS_TYPE: 24,
    TAX_ID: 25,
    STATE_PROVINCE: 26,

    GST_HST_NUMBER: 27,
    QST_NUMBER: 28,

    EMAIL: 101,
    EMAIL_NA: 102,
    MOBILE_PHONE: 110,
    HOME_PHONE: 120,
    WORK_PHONE: 130,
    PREFERRED_LANGUAGE: 900,

    PHYSICAL_COUNTRY_CODE: 900,
    PHYSICAL_ADDRESS_LINE_1: 201,
    PHYSICAL_ADDRESS_LINE_2: 202,
    PHYSICAL_CITY: 203,
    PHYSICAL_STATE: 204,
    PHYSICAL_ZIP: 205,

    PRIVACY_POLICY: 300,
    SECOND_SAVE_BUTTON: 301,
    SAME_AS_PHYSICAL_ADDRESS: 399,
    MAILING_COUNTRY_CODE: 900,
    MAILING_ADDRESS_LINE_1: 401,
    MAILING_ADDRESS_LINE_2: 402,
    MAILING_CITY: 403,
    MAILING_STATE: 404,
    MAILING_ZIP: 405,
    SAVE_BUTTON: 410,
    HOME_FAX: 900,
    WORK_FAX: 900,
    RESET_BUTTON: -1

};

export const businessFieldTypeClassMap = {
    businessName1: styles.businessNameLabel,
    stateProvince: styles.businessNameLabel,
    businessType: styles.businessNameLabel,
    'jdf-business-taxId': styles.businessNameLabel,
    'gstHstNumber': styles.businessNameLabel,
    'qstNumber': styles.businessNameLabel
};
